<template>
	<el-dialog :title='title' v-model="dialogFormVisible">
		<div>
			<div class="upload">
				<!-- accept="video/*" -->
				<input v-if="!disable" accept="video/mp4" type="file" @change='upload_plus($event)'>
				<el-button type='success' :disabled='disable'>上传</el-button>
			</div>
			<div style="margin-top: 20px;" v-if="percent.total">
				<el-progress  style="width: 100%;" :text-inside="true" :stroke-width="26" :percentage="p"></el-progress>
			</div>
		</div>
	</el-dialog>
	<slot>
		<el-button :type='type' :size='size' @click='dialogFormVisible=true'>{{buttonTitle}}</el-button>
    </slot>
</template>

<script>
	export default{
		name:'UploadPlus',
		emits:['success-plus'],
		props: {
			buttonTitle: {
				type: String,
				default: '上传'
			},
			type: {
				type: String,
				default: 'primary'
			
			},
			size: {
				type: String,
				default: 'small'
			},
			customParams: {
				//更换  传参
				type: Array,
				default: function() {
			
					return [];
				}
			},
			//每个文件切割大小 3M
			slice_size: {
				type: Number,
				default: 3145728
			},
			//上传成功后是否自动关闭弹窗
			auto_close:{
				type:Boolean,
				default:false
			},
			//上传路径 上传至 /mnt/hgfs/img.cosonsen.com/product/upload_video 目录
			upload_path: {
				type: String,
				default: ''
			},
		},
		data(){
			return {
				title: '提示,只支持MP4格式',
				dialogFormVisible: false,
				disable:false,
				percent:{
					total:0,
					current:0
				},
				dir_name:'',
			}
		},
		methods:{
			/**
		   * 文件切割
		   * @param 文件 {Object} file 
		   * @param 开始切割文件的大小 {Object} startByte 0          3145728          ......
		   * @param 结束切割文件的大小 {Object} endByte   3145728    3145728+3145728  ......
		   */
			blobSlice(file, startByte, endByte){
				if (file.slice) {
				  return file.slice(startByte, endByte);
				} else if (file.webitSlice) {
				  return file.webkitSlice(startByte, endByte);
				} else if (file.mozSlice) {
				  return file.mozSlice(startByte, endByte);
				} else {
				  return null;
				}
				// console.log(file, startByte, endByte)
			},
			//大文件上传 只针对单文件
			async upload_plus(e){
				// console.log(e)
				if (e.target.files[0].length <= 0) return this.alertWarn('文件未上传!!!');
				if(this.upload_path=='') return this.$message.error('未指定上传目录')
				
				let size = e.target.files[0].size;
				// console.log(e.target.files)
				let total = Math.ceil(size/this.slice_size);  //切割文件块 的 数量
				this.disable=true;
				
				this.percent.total = total;//赋值 上传进度 长度
				
				for(let i=0; i< total; i++){
					let file = this.blobSlice(e.target.files[0], i*this.slice_size, i*this.slice_size + this.slice_size);
					
					let form = new FormData();

					form.append('file', file);   //文件对象
					
					form.append('total', total); //切割文件块 的 总数量
					
					form.append('current', i + 1);//切割文件块 当前 块数
					
					form.append('dir_name', this.dir_name); //临时文件夹名称
					
					form.append('name', e.target.files[0].name); //文件名
					
					form.append('upload_path', this.upload_path); //上传目录
					//调用上传大文件方法
					let data = await this.upload(form);
					// console.log(data)
					
					this.percent.current=i+1;
					
					if(data.code == 1 && data.msg=='success-upload'){
						this.resetObj(this.percent)
						if(this.auto_close) this.dialogFormVisible=false;
						this.$emit('success-plus',data.data,this.customParams);
						this.disable=false;
					}
					
				}
			},
			upload(form){
				return new Promise((success,fail)=>{
					this.httpPost({
						url: '/admin/upload/uploadForBigFile',
						data: form
					}).then((re) => {
						success(re)
						this.dir_name = re.data.dir_name; //将第一次上传的文件块 父级目录 复用 再次传递到后端
					}).catch((err) => {
						this.resetBigFile();
						fail(err)
					})
				})
			},
			resetBigFile(){
				//重置 大文件上传  data
				this.disable=false;
				this.resetObj(this.percent);
			}
		},
		computed: {
			  /**
			   * 计算百分比
			   */
			p(){
				if(this.percent.total==0) return 0;
				return Math.ceil(this.percent.current/this.percent.total*100);
			}

		},
		created() {
			
		}
	}
</script>

<style>
	.upload {
    position: relative;
    width: -webkit-fit-content;

  }

  .upload>input {
    width: 100%;
    height: 100%;
    opacity: 0;
    position: absolute;

  }
</style>
